import React from 'react';
import { Translation, Trans } from 'react-i18next';
import globe from '../../../ASUPhotos/icons/me3_Globe.svg';
import laptop from '../../../ASUPhotos/icons/me3_Laptop.svg';
import diploma from '../../../ASUPhotos/icons/me3_Diploma.svg';
import prepdigital from '../../../ASUPhotos/icons/me3_prepdigital_laptop.png';
import { TopDashboardComponent } from './TopDashboardComponent';
import { Benefits } from './Benefits';

export default class ASUPrepDigital extends React.Component {
  primaryColor = {
    color: this.props.tenant.primary,
  };

  render() {
    const { tenant } = this.props;
    return (
      <Translation>
        {(t) => (
          <div id="asu-prep-digital" className="asu-prep-digital">
            <TopDashboardComponent
              tenant={tenant}
              headerText="ASU Prep Digital"
              appendText="asu-prep-digital"
              cornerImage={prepdigital}
              altText={t('A graduation taking place online')}
              copyDescription={t(
                'ASU Prep Digital is an accredited K-12 online school where you can take a single online course or enroll in a full-time, diploma-granting program. Because we are part of Arizona State University, we offer an accelerated path toward college admission and the chance to earn concurrent high school and university credit.'
              )}
              copyWebsiteLink={t('Visit the {{websiteName}} website', {
                websiteName: 'ASU Prep Digital',
              })}
              websiteLink="https://www.asuprepdigital.org/"
              primaryColor={this.primaryColor}
            />
            <Benefits
              appendText="asu-prep-digital"
              title={t('{{onlineProgram}} could be good for you if...', {
                onlineProgram: 'ASU Prep Digital',
              })}
              benefitOneJsx={
                /* eslint-disable-next-line react/jsx-wrap-multilines */
                <Trans>
                  <span>You want to take an </span>
                  <a
                    rel="noreferrer noopener"
                    target="_blank"
                    href="https://www.asuprepdigital.org/k-12-catalog/"
                    style={this.props.tenant.primaryColor}
                    className="asu-prep-digital__benefits asu-prep-digital__link"
                  >
                    online course
                  </a>
                  <span> not offered at your school</span>
                </Trans>
              }
              benefitTwo={t('You want to earn college credit in high school')}
              benefitThree={t(
                'You want the flexibility of attending an online high school full-time'
              )}
              imageOne={laptop}
              imageTwo={diploma}
              imageThree={globe}
            />
          </div>
        )}
      </Translation>
    );
  }
}
